import { render, staticRenderFns } from "./ClinicianHomeTabs.vue?vue&type=template&id=f1567e2e"
import script from "./ClinicianHomeTabs.vue?vue&type=script&lang=js"
export * from "./ClinicianHomeTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports